<template>
  <v-window v-model="tab">
    <v-window-item>
      <list ref="tab0" :open-tab="openTab"/>
    </v-window-item>
    <v-window-item>
      <detail ref="tab1" :open-tab="openTab" :item="item"/>
    </v-window-item>
    <v-window-item>
      <create ref="tab2" :open-tab="openTab" :item="item"/>
    </v-window-item>
  </v-window>
</template>

<script>

import List from "./List";
import Detail from "./Detail";
import Create from "./Create";

export default {
  name: "SosCase",
  components: {Create, Detail, List},
  data() {
    return {
      item: null,
      tab: 0,
    };
  },
  methods: {
    openTab(tab, data) {
      this.tab = tab
      this.item = data
      let t = this.$refs[`tab${tab}`]
      if (t) return t.onTab(this.item)
    },
  },
}
</script>

<style scoped>

</style>